import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import AppsIcon from '@material-ui/icons/Apps';
import { accessApi, oidcAuthApi } from './api';

export const appsRouteRef = createRouteRef();
export const appRouteRef = createRouteRef({ params: ['key'] });

const appsPage = PageBlueprint.make({
  params: {
    path: '/',
    title: 'Início',
    icon: <AppsIcon />,
    routeRef: appsRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/AppsPage').then(m => <m.AppsPage />),
  },
});

const appPage = PageBlueprint.make({
  name: 'app',
  params: {
    path: '/app/:key',
    routeRef: appRouteRef,
    noHeader: true,
    loader: () => import('./components/AppPage').then(m => <m.AppPage />),
  },
});

export const consolePlugin = createFrontendPlugin({
  pluginId: 'console',
  title: 'Kovi Console',
  routes: {
    apps: appsRouteRef,
    app: appRouteRef,
  },
  extensions: [oidcAuthApi, accessApi, appsPage, appPage],
});
